import Select, { components } from 'react-select';

type ButtonDropdownProps = {
  options: {
    value: string;
    label: string;
  }[];
  onChange?: (val: any) => void;
  height?: 'h-[41px]' | 'h-[25px]' | 'h-[37px]';
  id?: string;
  customBorderRadius?: any;
  className?: string;
  icon: any;
  value: string;
};

export const ButtonDropdown = ({
  options,
  height = 'h-[41px]',
  customBorderRadius,
  onChange,
  icon,
  value,
  className,
}: ButtonDropdownProps) => {
  return (
    <div>
      <Select
        onChange={onChange}
        value={options.find((o) => o.value === value) || null}
        options={options}
        className={`relative flex w-full items-center text-dark-blue`}
        placeholder=""
        isSearchable={false}
        components={{
          SingleValue: (props) => {
            const selected = props.getValue()[0];
            if (!selected) return null;

            return (
              <components.SingleValue {...props}>
                {selected.label}
              </components.SingleValue>
            );
          },
          IndicatorSeparator: () => null,
          DropdownIndicator: () => (
            <div style={{ pointerEvents: 'none' }}>{icon}</div>
          ),
        }}
        classNames={{
          control: (props: any) =>
            `${className} font-montserrat text-sm font-medium`,
          singleValue: (props: any) => `!text-current pr-2`,
        }}
        styles={{
          control: (base) => ({
            ...base,
            width: value ? 'auto' : '52px',
            height: '41px',
            minHeight: '41px',
            borderRadius: customBorderRadius || '4px',
            padding: '0 16px',
            backgroundColor: '#f3f4f6',
            border: 'none',
            justifyContent: 'center',
            boxShadow: 'none',
            cursor: 'pointer',
          }),
          valueContainer: (base) => ({
            ...base,
            padding: 0,
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
            marginTop: '4px',
            minWidth: '200px',
            zIndex: 10,
          }),
          option: (base, props) => ({
            ...base,
            cursor: 'pointer',
            backgroundColor: props.isSelected ? '#213A51' : 'white',
            ':hover': {
              backgroundColor: '#00E7FF',
            },
          }),
          menuList: (base) => ({
            ...base,
            padding: 0,
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: '16px',
          }),
        }}
      />
    </div>
  );
};
